module.exports = __webpack_public_path__ + "static/media/vinicius.b92e273c.jpg";